import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "hi");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cart") || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("lang", lang); document.documentElement.lang = lang; }, [lang]);
  useEffect(() => { localStorage.setItem("cart", JSON.stringify(cart)); }, [cart]);

  const checkAuth = useCallback(async () => {
    // Skip if returning from OAuth callback
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch { setUser(null); }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("session_token");
    setUser(null);
  };

  const addToCart = (med) => {
    setCart(prev => {
      const found = prev.find(p => p.medicine_id === med.medicine_id);
      if (found) return prev.map(p => p.medicine_id === med.medicine_id ? { ...p, qty: p.qty + 1 } : p);
      return [...prev, { medicine_id: med.medicine_id, name: med.name, price: med.price, qty: 1, image: med.image }];
    });
  };
  const updateQty = (id, qty) => {
    if (qty <= 0) return setCart(prev => prev.filter(p => p.medicine_id !== id));
    setCart(prev => prev.map(p => p.medicine_id === id ? { ...p, qty } : p));
  };
  const clearCart = () => setCart([]);

  return (
    <AppContext.Provider value={{ lang, setLang, user, setUser, loading, logout, cart, addToCart, updateQty, clearCart, refreshAuth: checkAuth }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
